<template>
	<div class="basis-page-cls">
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
                <div class="btns">
                    <el-button @click.stop="handleCreate" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增规则</el-button>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNumber"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList" />
            </div>
        </section>

		<el-drawer 
            :title="dialog_status == 'create' ? '新增规则' : '修改规则'" 
            :visible.sync="dialog_visible_touch_in"
            :wrapperClosable="false"
			size="600px"
            direction="rtl">
            <el-form labelPosition="right" autoComplete="on" labelWidth="120px" :model="api_form" ref="api_form">
				 <el-form-item label="品牌标识：">
                    <span>{{userInfo.brandIdentify}}</span>
                </el-form-item>
                <el-form-item prop="ruleCode" label="规则代码：" :rules="[{required: true, trigger: 'blur', validator: validateRuleStr}]">
                    <el-input v-model="api_form.ruleCode" :disabled="api_form.ruleStatus == '0' && dialog_status === 'update'" placeholder="请输入规则代码(8~32位数字字母)" style="width:450px;" clearable></el-input>
                </el-form-item>
                <el-form-item prop="subjectId" label="目标主题：" :rules="[{required: true, trigger: 'change', message: '请选择目标主题'}]">
                    <!-- <el-select v-model="api_form.subjectId" placeholder="请选择目标主题" style="width:450px;">
                        <el-option v-for="item in []" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select> -->
					<el-select v-model="api_form.subjectId"  placeholder="请选择目标主题" size="small" :disabled="api_form.ruleStatus == '0' && dialog_status === 'update'" clearable filterable style="width:450px;">
						<el-option v-for="(item,index) in subjectList" :key="index"
							:label="item.subjectName"
							:value="item.subjectId">
						</el-option>
					</el-select>
                </el-form-item>
				<el-form-item prop="ruleStatus" label="状态：" :rules="[{required: true, trigger: 'blur', message: '请选择状态'}]">
                    <el-switch v-model="api_form.ruleStatus" active-value="0" inactive-value="1" active-color="#13ce66" active-text="启用" inactive-text="待启用"></el-switch>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item style="float: right;padding-right: 30px;">
                    <el-button @click="dialog_visible_touch_in = false" size="small">取 消</el-button>
                    <el-button @click.stop="create" :loading="loading" v-if="dialog_status === 'create'" type="primary" size="small">提 交</el-button>
					<el-button @click.stop="update" :loading="loading" v-else type="primary" size="small">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin } from "utils/mixins";
import { validateRuleStr } from "utils/validator";
export default {
	mixins: [EnumMixin],
	computed: {
        ...mapGetters([
			'userInfo',  
		])
    },
	data() {
		return {
			validateRuleStr,
            column: [
				{ label: '规则代码', prop: 'ruleCode' },
				{ label: '目标主题', prop: 'subjectName' },
				{ label: '数据量', prop: 'taskCount' },
				{
                    label: '状态',
                    render: (h, scope) => {
                        return <el-tag type={scope.row.ruleStatus == '0' ? 'success' : 'info'} size="small">{scope.row.ruleStatus == '0' ? '已启用' : '待启用'}</el-tag>
                    }
                },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 180,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-link  v-copy={window.location.origin + '/call/ob/original/createOrignalDataByInterface.json'} underline={false} type="primary">复制API</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handleUpdate(scope.row)} underline={false} type="primary">修改</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handleDelete(scope.row)} disabled={scope.row.ruleStatus == '0'} underline={false} type="danger">删除</el-link>
							</div>
						)
                    }
                }
            ],
			listQuery: {
				pageSize: 10,
                pageNumber: 1,
				brandIdentify: ''
            },
			total: 0,
			list: [],
			loading: false,
			remoteFalse: false,
			dialog_status: 'create',
			dialog_visible_touch_in: false,
			api_form: {
				brandIdentify: '',
				ruleCode: '',
				ruleStatus: '0',
				subjectId: ''
			},
			subjectList: []
		}
    },
	async created() {
		await this.getList();
		await this.getSubjectIdForHeader();
	},
	methods: {
		getList() {
			this.listQuery.brandIdentify = this.userInfo.brandIdentify;
			this.$api.getPostCallApiRuleList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
				this.total = parseInt(response.total);
			});
		},
		handleCopy() {
			document.execCommand("Copy");
		},
		handleCreate() {
			this.resetForm();
			this.dialog_status = 'create';
			this.dialog_visible_touch_in = true;
		},
		handleUpdate(row) {
			this.resetForm();
			this.dialog_status = 'update';
			this.api_form = Object.assign(this.api_form, row);
			this.dialog_visible_touch_in = true;
		},
		handleDelete(row) {
			this.$confirm('此操作将删除该规则, 是否继续?', '系统提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.getPostCallApiRuleDelete({
					brandIdentify: row.brandIdentify,
					ruleId: row.ruleId
				}).then(response => {
					if(response.errcode != 0) return;
					this.$notify({
						title: "删除成功",
						type: "success"
					});
					this.getList();
				});
			}).catch(() => {});
		},
		create() {
			this.$refs["api_form"].validate(valid => {
                if (valid) {
                    this.loading = true;
					this.api_form.brandIdentify = this.userInfo.brandIdentify;
                    this.$api.getPostCallApiRuleCreate(this.api_form).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						};
                        this.$notify({
                            title: "新增成功",
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		update() {
			this.$refs["api_form"].validate(valid => {
                if (valid) {
                    this.loading = true;
					this.api_form.brandIdentify = this.userInfo.brandIdentify;
                    this.$api.getPostCallApiRuleUpdate( this.api_form).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						};
                        this.$notify({
                            title: "修改成功",
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		resetForm() {
			this.api_form = {
				brandIdentify: '',
				ruleCode: '',
				ruleStatus: '0',
				subjectId: ''
			}
			if (this.$refs["api_form"]) {
				this.$refs["api_form"].clearValidate();
			}
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList();
		},
		getSubjectIdForHeader(){
			this.$api.getBreathThemeList({
				brandIdentify: this.userInfo.brandIdentify,
				childBrandIdentify: '',
				campaignId: '',
				pageSize: 999,
				pageNumber: 1,
				subjectName: ''
			}).then(res => {
				if(res.errcode != 0) return;
				this.subjectList = res.data;
			})
		},
    }
}
</script>